import { IProductService } from '@src/types/Product';
import { Api } from '@src/types/api';
import { ServiceReference, ServiceName } from '@src/types/Services';
import { ProductView } from 'common';

/**
 * Product service
 */
export class ProductService implements IProductService {
  private apiService?: Api;

  public constructor(
    servicesPromise: ServiceReference,
  ) {
    servicesPromise.then((services) => {
      this.apiService = services.get<Api>(ServiceName.Api);
    });
  }

  /**
     * Get products from the api
     */
  public async fetchProducts(productIds: string[]): Promise<ProductView[]> {
    if (!productIds.length) {
      return [];
    }
    return this.apiService?.getProducts({ ids: productIds }).catch((e) => {
      console.error(e);
      return [];
    }) || [];
  }
}
